"use strict";

import {Component, ElementRef, Input, OnChanges} from "@angular/core";
import {Tools} from "linkurious-shared";
import set = Reflect.set;

@Component({
  selector: 'truncate',
  template: `<span [tooltip]="value"
                   [maxWidth]="400"
                   [truncation]="500"
                   [copy]="true"
                   [disabled]="value?.length <= charLimit">
                {{value | truncate:position:charLimit}}
              </span>`
})
export class TruncateComponent implements OnChanges {
  @Input() public value: string;
  @Input() public lines: number = 1;
  @Input() public position: 'middle'|'end' = 'middle';
  @Input() private limit: string;
  public charLimit: number = 0;

  constructor(
    private _element: ElementRef
  ) {}

  ngOnChanges() {
    if ( Tools.isDefined(this.value) ) {
      this.charLimit = this.getCharLimit();
    }
  }

  private getCharLimit(): number {
    if ( this.limit.includes('px') ) {
      return this.processLimitFromPixels(Tools.parseNumber(this.limit.replace('px', '')));
    } else if ( this.limit === 'fit' ) {
      return this.processLimitFromPixels(this.getInheritedWidth(this._element.nativeElement.parentElement));
    } else {
      return Tools.parseNumber(this.limit);
    }
  }

  private getInheritedWidth(el: HTMLElement): number {
    let width = window.getComputedStyle(el, null).getPropertyValue('width');
    if ( width !== '0px' && width !== 'auto' ) {
      return Tools.parseNumber(width.replace('px', ''));
    } else {
      return this.getInheritedWidth(el.parentElement);
    }
  }

  private processLimitFromPixels(pxLimit: number): number {
    let virtualElement = document.createElement('div');
    virtualElement.style.position = 'fixed';
    virtualElement.style.left = '-9999px';
    virtualElement.style.fontSize = window.getComputedStyle(this._element.nativeElement, null).getPropertyValue('font-size');
    virtualElement.style.fontFamily = window.getComputedStyle(this._element.nativeElement, null).getPropertyValue('font-family');
    let text = document.createTextNode(this.value + '\u2026');
    virtualElement.appendChild(text);
    document.body.appendChild(virtualElement);
    let width = +window.getComputedStyle(virtualElement, null).getPropertyValue('width').replace('px', '');
    document.body.removeChild(virtualElement);
    let factor = ((this.value.length + 1) / 2) / this.value.length;
    let charSize = Math.ceil(width / (this.value.length * factor));
    return Math.floor((pxLimit / charSize) * +this.lines);
  }
}
